export default __webpack_public_path__ + "static/handpicked-series-4407590daf210fb2e0319b17254eb1c0.pdf";